import React from 'react'
import {AccountPage} from '@components/account/account'
import {DashboardPage} from '@components/dashboard/dashboard'
import {EventFeedPage} from '@components/event-feed/event-feed-page'
import {MyTasks} from '@components/my-tasks/my-tasks'
import {OthersTasks} from '@components/my-tasks/other-tasks'
import {usePage} from '@containers/hooks'
import {Page} from '@extensions/page'
import {PageService} from '@extensions/page-service'

interface PageItemProps {
  page: Page
  element: React.ReactNode
}

const Item = ({page, element}: PageItemProps) => {
  const currentPage = PageService.getPage()
  return currentPage === page ? (
    <div className="absolute z-10 w-full h-full overflow-auto text-14">
      {element}
    </div>
  ) : null
}

export const PageContainer = () => {
  usePage()
  return (
    <div>
      <Item page="event-feed" element={<EventFeedPage />} />
      <Item page="my-tasks" element={<MyTasks />} />
      <Item page="others-tasks" element={<OthersTasks />} />
      <Item page="settings-account" element={<AccountPage />} />
      <Item page="projects" element={<DashboardPage />} />
    </div>
  )
}
